export const environment = {
  production: true,
  apiUrl: 'https://ecommerce-camben-backend.onrender.com/'
};
